//
// Software Name: Orange Design System Charts
// SPDX-FileCopyrightText: Copyright (c) 2023 - 2026 Orange SA
// SPDX-License-Identifier: MIT
//
// This software is distributed under the MIT license.
//
export var MainAxisType;
(function (MainAxisType) {
    MainAxisType["category"] = "category";
    MainAxisType["time"] = "time";
})(MainAxisType || (MainAxisType = {}));
export function isMainAxis(axis) {
    return axis && (axis.data || (axis.type && Object.values(MainAxisType).includes(axis.type)));
}
